import { createElement } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Layout } from '~/components/Layout'
import { RootRedirect } from '~/pages/RootRedirect'
import { AssessmentPage } from '~/pages/AssessmentPage'
import { ResultsPage } from '~/pages/ResultsPage'
import { SignupPage } from '~/pages/SignupPage'
import { LoginPage } from '~/pages/LoginPage'
import { ForgotPasswordPage } from '~/pages/ForgotPasswordPage'
import { ResetPasswordPage } from '~/pages/ResetPasswordPage'
import { DashboardPage } from '~/pages/DashboardPage'
import { DeeperInsightsPlaceholderPage } from '~/pages/DeeperInsightsPlaceholderPage'
import { ComputingResultsPage } from '~/pages/ComputingResultsPage'
import { TipsPage } from '~/pages/TipsPage'
import { PerspectivesPage } from '~/pages/PerspectivesPage'
import { ProfilePage } from '~/pages/ProfilePage'
import { ChangePasswordPage } from '~/pages/ChangePasswordPage'
import { AccountDetailsPage } from '~/pages/AccountDetailsPage'
import { NotificationPreferencesPage } from '~/pages/NotificationPreferencesPage'
import { VerifyEmailPage } from '~/pages/VerifyEmailPage'
import { PortraitOnboardingPage } from '~/pages/PortraitOnboardingPage'
import { PortraitCelebrationPage } from '~/pages/PortraitCelebrationPage'
import { AskDynamoPage } from '~/pages/AskDynamoPage'
import { ManageDogsPage } from '~/pages/ManageDogsPage'
import { DogDetailsPage } from '~/pages/DogDetailsPage'
import { AddDogPage } from '~/pages/AddDogPage'
import { AddDogPhotoPage } from '~/pages/AddDogPhotoPage'
import { StoryPage } from '~/pages/StoryPage'
import { StoryNewPage } from '~/pages/StoryNewPage'
import { StoryDetailPage } from '~/pages/StoryDetailPage'
import { PrivacyPage } from '~/pages/PrivacyPage'
import { PrivacyPolicyPage } from '~/pages/PrivacyPolicyPage'
import { TermsOfServicePage } from '~/pages/TermsOfServicePage'
import { SubscriptionPage } from '~/pages/SubscriptionPage'
import { ChooseFreeDogPage } from '~/pages/ChooseFreeDogPage'

export const routes: RouteObject[] = [
  {
    element: createElement(Layout),
    children: [
      { path: '/', element: createElement(RootRedirect) },
      { path: '/assessment', element: createElement(AssessmentPage) },
      { path: '/assessment/results', element: createElement(ComputingResultsPage) },
      { path: '/results', element: createElement(ResultsPage) },
      { path: '/signup', element: createElement(SignupPage) },
      { path: '/verify-email', element: createElement(VerifyEmailPage) },
      { path: '/login', element: createElement(LoginPage) },
      { path: '/forgot-password', element: createElement(ForgotPasswordPage) },
      { path: '/reset-password', element: createElement(ResetPasswordPage) },
      { path: '/dashboard', element: createElement(DashboardPage) },
      { path: '/onboarding/portrait', element: createElement(PortraitOnboardingPage) },
      { path: '/onboarding/portrait/celebrate', element: createElement(PortraitCelebrationPage) },
      { path: '/ask-dynamo', element: createElement(AskDynamoPage) },
      { path: '/tips', element: createElement(TipsPage) },
      { path: '/perspectives', element: createElement(PerspectivesPage) },
      { path: '/profile', element: createElement(ProfilePage) },
      { path: '/account', element: createElement(AccountDetailsPage) },
      { path: '/notifications', element: createElement(NotificationPreferencesPage) },
      { path: '/change-password', element: createElement(ChangePasswordPage) },
      { path: '/plus', element: createElement(DeeperInsightsPlaceholderPage) },
      { path: '/deeper-insights', element: createElement(DeeperInsightsPlaceholderPage) },
      { path: '/pack/manage', element: createElement(ManageDogsPage) },
      { path: '/pack/dogs/:id', element: createElement(DogDetailsPage) },
      { path: '/pack/add', element: createElement(AddDogPage) },
      { path: '/pack/add/photo', element: createElement(AddDogPhotoPage) },
      { path: '/story', element: createElement(StoryPage) },
      { path: '/story/new', element: createElement(StoryNewPage) },
      { path: '/story/:entryId', element: createElement(StoryDetailPage) },
      { path: '/privacy', element: createElement(PrivacyPage) },
      { path: '/privacy-policy', element: createElement(PrivacyPolicyPage) },
      { path: '/terms', element: createElement(TermsOfServicePage) },
      { path: '/subscription', element: createElement(SubscriptionPage) },
      { path: '/choose-free-dog', element: createElement(ChooseFreeDogPage) },
    ],
  },
]
